import { NgModule } from "@angular/core";
import { SettingsMenuBtnComponent } from "./settings-menu-btn.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
  imports: [FontAwesomeModule],
  declarations: [SettingsMenuBtnComponent],
  exports: [SettingsMenuBtnComponent]
})
export class SettingsMenuBtnModule {}
